<div class="card bg-white">
    <div style="width: 100%; height: 600px; display: flex;justify-content: center; align-items: center">
        <h1>403 Forbidden</h1>
    </div>
</div>

